import React from "react";
import AsyncSelect from "react-select/lib/Async";
import { withStyles, Paper } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Clear from "@material-ui/icons/CancelOutlined";

const style = (theme) => ({
  Dropdown: {
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor,
    maxWidth: 300,
  },
  menu: {
    borderRadius: "4px",
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor,
    minWidth: "100%",
    position: "absolute",
    bottom: 0,
    transform: "translateY(100%)",
  },
  menuList: {
    maxHeight: 200,
    overflow: "auto",
  },
  reactSelect: {
    "& .select__control": {
      minWidth: 130,
      backgroundColor: theme.ModalBGColor,
      minHeight: 24,
      maxHeight: "max-content",
      boxSizing: "border-box",
      borderRadius: 2,
      marginTop: 6,
      border: `1px solid ${theme.iconColor}`,
      fontSize: 12,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        borderRadius: 2,
        border: `1px solid ${theme.iconColor}`,
      },
      "& .select__value-container": {
        height: 22,
        color: theme.TextColor,
        padding: "0px 8px",
        "& .select__input": {
          height: 22,
          color: theme.TextColor,
          "&>input": {
            height: 22,
          },
        },
        "&>div": {
          margin: 0,
          padding: 0,
        },
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__indicators": {
        height: 22,
        "& .select__indicator": {
          padding: 5,
          height: 24,
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
      "& .select__value-container--is-multi": {
        paddingTop: 0,
        paddingBottom: 0,
        "&.select__value-container": {
          height: "max-content",
          "& .select__multi-value": {
            backgroundColor: theme.AppBGColor,
            color: theme.TextColor,
            margin: "2px",
            "& .select__multi-value__label": {
              color: theme.TextColor,
            },
          },
        },
      },
    },
  },

  iconStyle: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  error: {
    color: theme.error,
  },
});

const SearchSelect = ({
  classes,
  autoFocus,
  OptionRenderer,
  isClearable,
  reactContainer,
  fetchOptions,
  inputRef,
  hasError,
  errorMessage,
  ...otherProps
}) => {
  const noOptionsMessage = () => {
    const message = hasError ? errorMessage : "No options";
    return <span className={hasError ? classes.error : null}>{message}</span>;
  };

  if (reactContainer) {
    reactContainer.className = classes.Dropdown;
  }
  return (
    <AsyncSelect
      ref={inputRef}
      autoFocus={autoFocus ?? true}
      isClearable={isClearable ?? true}
      classNamePrefix={"select"}
      className={classes.reactSelect}
      defaultOptions
      loadOptions={fetchOptions}
      noOptionsMessage={noOptionsMessage}
      components={{
        DropdownIndicator: (props) => (
          <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />
        ),
        ClearIndicator: (props) => (
          <Clear {...props.innerProps} className={classes.iconStyle} />
        ),
        Option: (props) => <OptionRenderer props={props} />,
        Menu: (props) => {
          return (
            <Paper className={classes.menu} {...props.innerProps} square>
              {props.children}
            </Paper>
          );
        },
        MenuList: (props) => {
          return (
            <div
              ref={props.innerRef}
              className={`${classes.menuList} customScroll`}
            >
              {props.children}
            </div>
          );
        },
        LoadingIndicator: (_props) => {
          return null;
        },
      }}
      {...otherProps}
    />
  );
};

export default withStyles(style)(SearchSelect);

